banners_inter = {
    breakpoints_list : {
        'default': 0,
    
        'sm': 640,
        // => @media (min-width: 640px) { ... }
    
        'md': 768,
        // => @media (min-width: 768px) { ... }
    
        'lg': 1024,
        // => @media (min-width: 1024px) { ... }
    
        'xl': 1280,
        // => @media (min-width: 1280px) { ... }
    
        '2xl': 1536,
        // => @media (min-width: 1536px) { ... }
    },
    generatePictureResponsive : function(object_images) {

        object_as_array = Object.keys(object_images).map((key) => [key, object_images[key]]);
    
        object_as_array.sort((a, b) => {
            return this.breakpoints_list[b[0]] - this.breakpoints_list[a[0]];
        });
    
        string = '<picture class="picture_banner w-full">'
        for (const [key, value] of object_as_array) {
            if(key != 'default') {
                string += `<source srcset="${value}" media="(min-width: ${this.breakpoints_list[key]}px)" />`
            }
        }
        string += `<img class="rounded-[25px] w-full img_banner" loading="lazy" src="${object_images.default}"
        onerror="(() => {
            this.classList.remove('block')
            this.classList.add('hidden')
        })();return false;"
        onload="(() => {
            this.classList.add('block')
            this.classList.remove('hidden')
            reLayout()
        })()" />`
        string += '</picture>'
    
        // console.log(string)
        return string
    
    },
    reorderBanners: function(promos, filteredItems, distance_banners, containerInDom) {
        if (promos.length > 0) {
    
            window.fireLazy()
            if (window.justFired) {
    
                let index = 0;
                for (item of filteredItems) {
                    if (!((index + 1) % distance_banners == 0)) {
                        // $(item.element).find(".ad-banner-item").slideUp(0);
                    } else {
                        index_promo = Math.floor(index / distance_banners) % promos.length
                        $(item.element).find(".ad-banner-item").find(".picture_banner").replaceWith(this.generatePictureResponsive(promos[index_promo]));
    
                        $(item.element).find(".ad-banner-item").addClass("block").removeClass("hidden");
                    }
                    index += 1
                }
                window.justFired = false;
                // setTimeout(function () { containerInDom.isotope('layout') }, 300);
                // setTimeout(function () { containerInDom.isotope('layout') }, 3000);
            }
        }
    }
}

window.reorderBanners =  banners_inter